import {faRedo, faUndo} from '@fortawesome/free-solid-svg-icons'
import {useAppDispatch, useAppSelector} from '../../stores/configureStore'
import {
  isNextImageHistoryItemAvailable,
  isPreviousImageHistoryItemAvailable,
  nextImageHistoryItem,
  previousImageHistoryItem,
} from '../../utils/helpers/editorHistory'
import IconButton from './IconButton'
import cssMobile from '../../css/editorMobile.module.css'

export default function HistoryButtonsMobile() {
  const dispatch = useAppDispatch()
  const editorStore = useAppSelector(store => store.editor)

  return (
    <div className={cssMobile.historyButtons}>
      {isPreviousImageHistoryItemAvailable(editorStore) && (
        <IconButton
          icon={faUndo}
          color="primary"
          onClick={() => {
            previousImageHistoryItem(dispatch, editorStore)
          }}
        />
      )}
      {isNextImageHistoryItemAvailable(editorStore) && (
        <IconButton
          icon={faRedo}
          color="primary"
          onClick={() => {
            nextImageHistoryItem(dispatch, editorStore)
          }}
        />
      )}
    </div>
  )
}
